export function base64ToBytes(base64: string): Uint8Array<ArrayBuffer> {
  // ArrayBuffer backing so the result is assignable to DOM BufferSource (Web Crypto).
  return Uint8Array.from(atob(base64), m => m.codePointAt(0) || 0)
}

export function bytesToBase64(bytes: Uint8Array) {
  return btoa(Array.from(bytes, byte => String.fromCodePoint(byte)).join(''))
}

export function bytesToBase64UrlSafe(bytes: Uint8Array) {
  return bytesToBase64(bytes)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '')
}

export function base64UrlSafeToBytes(base64: string): Uint8Array<ArrayBuffer> {
  return base64ToBytes(base64.replace(/-/g, '+').replace(/_/g, '/'))
}
